import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
import { PaginationResponse } from "@/core/services/api/interfaces/PaginationResponse";
import ApiService from "@/core/services/ApiService";
import { AxiosRequestConfig } from "axios";
import { isUserManager } from "@/core/services/UserRoleService";
import { Announcement } from "@/core/services/api/interfaces/manager/Announcement";

@Module
export default class AnnouncementsModule extends VuexModule {
  pagination = new PaginationResponse<Announcement>();
  loading = false;

  get announcements(): Announcement[] {
    return this.announcementsPagination.data;
  }

  get announcementsLoading(): boolean {
    return this.loading;
  }

  get announcementsShouldBePulled(): boolean {
    return !this.loading && !this.pagination.data.length;
  }

  get announcementsPagination(): PaginationResponse<Announcement> {
    return this.pagination;
  }

  get announcementsTotal(): number {
    return this.pagination.total;
  }

  get announcementsRequired(): boolean {
    return !this.pagination.total && !this.loading;
  }

  get announcementsCurrentPage(): number {
    return this.pagination.current_page;
  }

  get announcementsPerPage(): number {
    return this.pagination.per_page;
  }

  @Action({ rawError: true })
  [Actions.MANAGER_ANNOUNCEMENTS_LOAD](params) {
    if (isUserManager() && !this.context.getters.isIndividualOrHas2FA) {
      return;
    }
    this.context.commit(Mutations.MANAGER_ANNOUNCEMENTS_SET_LOADING, true);

    ApiService.manager.announcement
      .list({
        params: params,
      } as AxiosRequestConfig)
      .then(ApiService.unwrapPaginationResponse)
      .then((response) => {
        this.context.commit(Mutations.MANAGER_ANNOUNCEMENTS_SET, response);
      })
      .catch(console.error)
      .finally(() => {
        this.context.commit(Mutations.MANAGER_ANNOUNCEMENTS_SET_LOADING, false);

        this.context.commit(
          Mutations.COMMON_REQUEST_DONE,
          Actions.MANAGER_ANNOUNCEMENTS_LOAD
        );
      });
  }

  @Mutation
  [Mutations.MANAGER_ANNOUNCEMENTS_SET](
    pagination: PaginationResponse<Announcement>
  ) {
    this.pagination = pagination;
  }

  @Mutation
  [Mutations.MANAGER_ANNOUNCEMENTS_RESET]() {
    this.pagination = new PaginationResponse<Announcement>();
  }

  @Mutation
  [Mutations.MANAGER_ANNOUNCEMENTS_SET_LOADING](loading: boolean) {
    this.loading = loading;
  }
}
